import React from 'react'
import { LinkBanner, Props } from 'component-library/banners/LinkBanner/LinkBanner'
import { createRegisterableComponent } from 'common/routing/page-definition'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface LinkBannerRouteProps extends Props {}

export const LinkBannerRegistration = createRegisterableComponent(
    'link-banner',
    (props: LinkBannerRouteProps) => <LinkBanner {...props} />
)
